import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { CaretDownIcon, UserIcon } from '@patternfly/react-icons';
import { logout } from '@app/utils/utils';
import { colors, radii } from '@app/components/designTokens';

interface UsernameDropdownProps {
  username?: string;
}

export const UsernameDropdown: React.FunctionComponent<UsernameDropdownProps> = ({ username }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const display = username || 'Operator';

  const styles: { [k: string]: React.CSSProperties } = {
    wrap: { position: 'relative' },
    trigger: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      padding: '6px 8px',
      borderRadius: radii.button
    },
    avatar: {
      width: 34,
      height: 34,
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 15
    },
    nameBox: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 },
    name: { fontSize: 14, fontWeight: 600, color: colors.title },
    badge: {
      fontSize: 10,
      fontWeight: 700,
      letterSpacing: '0.5px',
      color: colors.accent,
      textTransform: 'uppercase'
    },
    menu: {
      position: 'absolute',
      right: 0,
      top: '110%',
      background: '#fff',
      border: `1px solid ${colors.border}`,
      borderRadius: 12,
      boxShadow: '0 12px 32px rgba(15, 23, 42, 0.16)',
      minWidth: 180,
      padding: 6,
      zIndex: 200
    },
    item: {
      display: 'block',
      width: '100%',
      textAlign: 'left',
      background: 'transparent',
      border: 'none',
      padding: '10px 12px',
      fontSize: 14,
      color: colors.body,
      borderRadius: 8,
      cursor: 'pointer'
    }
  };

  return (
    <div style={styles.wrap} ref={ref}>
      <button style={styles.trigger} onClick={() => setOpen(o => !o)} aria-label="Account menu">
        <span style={styles.avatar}>
          <UserIcon />
        </span>
        <span style={styles.nameBox}>
          <span style={styles.name}>{display}</span>
          <span style={styles.badge}>Admin</span>
        </span>
        <CaretDownIcon style={{ color: colors.subtle }} />
      </button>
      {open && (
        <div style={styles.menu}>
          <button
            style={styles.item}
            onClick={() => logout()}
            onMouseEnter={e => (e.currentTarget.style.background = colors.bgMuted)}
            onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
};
